import { render, staticRenderFns } from "./MenusListView.vue?vue&type=template&id=3fb63553&"
import script from "./MenusListView.vue?vue&type=script&lang=js&"
export * from "./MenusListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports